module.exports = __webpack_public_path__ + "img/iconmonstr-check-mark-8.6dcc06e2.svg";